import Marquee from 'react-fast-marquee';
import { MARQUEE } from '@/constants/testIds';

const WORDS = [
	'Towing',
	'Jump Start',
	'Flat Tire',
	'Lockout',
	'Fuel Delivery',
	'Winch-Out',
	'24 / 7',
	'Nationwide',
	'Licensed & Insured',
	'Dispatch Live',
];

export const EditorialMarquee = ({ variant = 'red' }) => {
	const isRed = variant === 'red';
	return (
		<section
			data-testid={MARQUEE.root}
			className={`overflow-hidden border-y ${
				isRed
					? 'bg-brand-red text-white border-brand-red'
					: 'bg-white text-brand-navy border-brand-navy'
			}`}
		>
			<Marquee
				gradient={false}
				speed={45}
				autoFill
				pauseOnHover={false}
			>
				<div className="flex items-center py-6 sm:py-8">
					{WORDS.map((w, i) => (
						<span
							key={i}
							className="font-anton text-[52px] sm:text-[80px] md:text-[104px] leading-none uppercase whitespace-nowrap"
						>
							{w}
							<span className="marquee-dot" aria-hidden />
						</span>
					))}
				</div>
			</Marquee>
		</section>
	);
};

export default EditorialMarquee;
